export default class ToggleMenu {
    constructor(options) {
        this.body = options.body;
        this.html = options.html;
        this.triggerElement = options.triggerElement; // トリガーボタン
        this.menuOpenClass = options.menuOpenClass; // メニューオープン時にbodyタグに付与するクラス名
        this.rootClass = options.rootClass; // メニューオープン時にHTMLタグに付与するクラス名（スクロール抑制用）
        this.customOption = options.customOption || { useRootClass: true }; // カスタムオプション(デフォルトはtrue)

        this.initEventListener(); // イベントリスナーの初期化
    }

	// メニューの表示・非表示を切り替える
    toggleMenu() {
        const isOpen = this.body.classList.contains(this.menuOpenClass); // メニューが開いているかどうかを判定
        this.body.classList.toggle(this.menuOpenClass, !isOpen); // メニューの表示・非表示を切り替え
		// カスタムオプションがtrueかつルートクラスが設定されている場合
        if (this.customOption.useRootClass && this.rootClass) {
            this.html.classList.toggle(this.rootClass, !isOpen); // ルートクラスの表示・非表示を切り替え
        }
    }

	// イベントリスナーの初期化
    initEventListener() {
        this.triggerElement.addEventListener('click', this.toggleMenu.bind(this)); // トリガーボタンのクリックイベントにtoggleMenuメソッドを設定
    }
}